import { Facebook, Linkedin, Instagram, Youtube } from "lucide-react";
import logo from "../assets/logo-findeo.jpeg";

const socials = [Facebook, Linkedin, Instagram, Youtube];

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Findeo" className="h-11 w-11 rounded-full ring-2 ring-white/20" />
            <div className="font-display font-bold text-xl">GROUPE FINDEO</div>
          </div>
          <p className="mt-4 text-sm text-white/70 max-w-md leading-relaxed">
            Représentant officiel en Afrique de Obled Corporation. Nous construisons
            l'écosystème numérique africain de demain : santé, finance, éducation,
            immobilier et services digitaux.
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-white/70">
            {[
              ["#accueil", "Accueil"],
              ["#apropos", "À propos"],
              ["#solutions", "Nos solutions"],
              ["#partenaires", "Partenaires"],
              ["#investisseurs", "Investisseurs"],
              ["#contact", "Contact"],
            ].map(([h, l]) => (
              <li key={h}><a href={h} className="hover:text-royal transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-4">Contact</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Abidjan – Côte d'Ivoire</li>
            <li>info@groupefindeo.com</li>
            <li>+225 07 88 00 87 81</li>
            <li>+225 07 19 57 47 47</li>
            <li>+1 (518) 535-5959</li>
            <li><a href="https://www.groupefindeo.com" className="hover:text-royal transition-colors">www.groupefindeo.com</a></li>
          </ul>
          <div className="mt-5 flex gap-3">
            {socials.map((I, i) => (
              <a key={i} href="#" aria-label="social"
                className="h-9 w-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-gradient-brand hover:border-transparent transition">
                <I className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 py-5 text-xs text-white/60 flex flex-col md:flex-row items-center justify-between gap-2">
          <p>© 2026 Groupe FINDEO – Tous droits réservés. Représentant officiel de Obled Corporation en Afrique.</p>
          <p>Construit avec ambition à Abidjan.</p>
        </div>
      </div>
    </footer>
  );
}
